import GatedContent from './GatedContent';

import Paper from '@mui/material/Paper';

const rootCss = ({ spacing }) => ({
  maxWidth: '100%',
  width: 500,
  margin: spacing(2, 'auto'),
  padding: spacing(5, 3),
  display: 'flex',
  justifyContent: 'center',
});

export default function ActivityBlocked(props) {
  return (
    <Paper css={rootCss}>
      <GatedContent {...props} />
    </Paper>
  );
}
